import { motion } from 'framer-motion';
import FormEmail from '../FormEmail/FormEmail';
import Globes from './Glodes/Globes';
import { EmailReques } from '../../types/types';

const Connect = ({ setIsRequestSent }: EmailReques) => {
  return (
    <motion.section
      className='connect'
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className='connect__container'>
        <div className='connect__info'>
          <div className='connect__inner'>
            <motion.h1
              className='connect__title title '
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.6 }}
            >
              Connect Your Business
              <motion.span
                className='title color'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.9 }}
              >
                to International Customers
              </motion.span>
            </motion.h1>
            <motion.p
              className='connect__text text'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 1.2 }}
            >
              Customized Online Payment Services for Enterprises and Easy to
              Integrate Approach for Startups
            </motion.p>
          </div>
          <motion.div
            className='connect__form'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.5 }}
          >
            <FormEmail
              className='form'
              source='Connect'
              setIsRequestSent={setIsRequestSent}
              buttonText='Get started'
            />
          </motion.div>
        </div>
        <Globes className='connect__img globe' />
      </div>
    </motion.section>
  );
};

export default Connect;
